import React from 'react';
import _ from 'lodash';

import TreeSelect from 'components/Filters/TreeSelect';

const floorGroups = [
  {
    label: 'Lower Level (2-5)',
    floors: ['2', '3', '4', '5']
  },
  {
    label: 'Standard Level (6-14)',
    floors: ['6', '7', '8', '9', '10', '11', '12', '13', '14']
  },
  {
    label: 'Premium Level (15-19)',
    floors: ['15', '16', '17', '18', '19']
  }
];

interface FloorFilterProps {
  floors: Array<any>;
  filters: any;
  onChange: (value: Array<string>) => void;
}

const TccwFloorFilter = ({
  filters,
  onChange,
  floors = []
}: FloorFilterProps) => {
  const floorFilters = floorGroups.map(group => {
    const floorsForGroup = floors.filter(
      floor => floor && _.includes(group.floors, floor)
    );

    return {
      label: group.label,
      data: floorsForGroup.map((floorForGroup: string) => ({
        label: floorForGroup,
        key: floorForGroup
      }))
    };
  });

  return (
    <TreeSelect
      label="Floors"
      data={floorFilters}
      value={filters.floors}
      onFilterChange={onChange}
    />
  );
};

export default TccwFloorFilter;
